import configData from "../config/config.json";

export const getEntities = async(enabled = 'Y') => {
    try{
        const url = configData.CCBHTableauAPIServer + "/entities";

        const response = await fetch(url, { 
            method:"POST", 
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                "enabled": enabled
            }),
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        

};

export const getEntityTypes = async() =>{
    try{
        const url = configData.CCBHTableauAPIServer + "/entityTypes";

        const response = await fetch(url, { 
            method:"GET", 
            headers: {
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};

export const addEntity = async(entity_id, entity_type_id, entity_name) =>{
    const url = configData.CCBHTableauAPIServer + "/entity/add";

    const response = await fetch(url, {
        method: "POST",
        headers:{'Content-Type': 'application/json'},
        body: JSON.stringify({
            "name": entity_name,
            "id": entity_id,
            "type": parseInt(entity_type_id),
            "typeDescription": "new",
            "role": "new",
            "enabled": true
        }),
    });
    const responseJson = await response.json();
    console.log('Add Entity response:', responseJson);
    
    return responseJson;
};

export const delDisableEntity = async(entityId, disable) => {
    const url = configData.CCBHTableauAPIServer + "/entity/delDisable";

    const response = await fetch(url, {
        method: "POST",
        headers:{'Content-Type': 'application/json'},
        body: JSON.stringify({
            "id": entityId,
            "disable_YN": disable
        }),
    });
    const responseJson = await response.json();
    console.log('Del/Disable Entity response:', responseJson);
    
    return responseJson;
};

export const getUserRoleTypes = async() => {
    try{
        const url = configData.CCBHTableauAPIServer + "/userrolestypes";

        const response = await fetch(url, { 
            method:"GET", 
            headers: {
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }

};

export const refreshDirectReports = async(managerId) => {
    const url = configData.CCBHTableauAPIServer + "/RefreshDirectReports?webuserID=" + managerId ;
    try{
        const response = await fetch(url, {
            method:"GET",
            headers: {
                'webuserID': managerId
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};

export const deleteWebuserId = async(webuserID) => {
    const url = configData.CCBHTableauAPIServer + "/deleteuser?webuserID=" + webuserID;
    try{
        const response = await fetch(url, {
            method:"POST",
            headers:{
                "Content-Type": 'application/json',
                "webuserID": webuserID
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};

export const validUser = async(webuserID) => {
    const url = configData.CCBHTableauAPIServer + "/validuser?webuserID=" + webuserID;
    try{
        const response = await fetch(url, { 
            method:"GET", 
            headers: {
                'webuserID': webuserID,
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }    
};

export const getManagers = async() => {
    const url = configData.CCBHTableauAPIServer + "/managers";
    try{
        const response = await fetch(url, { 
            method:"GET", 
        });
        //console.log(response);
        const responseJson = await response.json();
        console.log("Get Managers");
        console.log("M: ", responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};

export const getManagersOptions = async(entityId) => {
    let options = null;
    let managers = await getManagers();
    
    if(entityId !== null && entityId !== undefined && entityId !== ""){
        managers = managers.filter((m) => {
            return m.entityId === entityId;
        });
    }
    options = managers.map(m => ({
        value: m.webuserId,
        label: m.name
    }));

    return options;
};

export const getManagersOptionsNew = async(entityId) => {
    let managers = await getManagers();
    
    if(entityId !== null && entityId !== undefined && entityId !== ""){
        managers = managers.filter((m) => {
            return (m.entityId === entityId || m.webuserId === "ccbhtabmanager");
        });
    }

    return managers;
};

const GET = async(searchURL) =>{
    const url = configData.CCBHTableauAPIServer + searchURL; //"/password/validatetimestamp?timeCode=" + timestamp;
    try{
        const response = await fetch(url, { 
            method:"GET", 
            headers: {
            },
        });
        const responseJson = await response.json();
        console.log(responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};

export const validTimeStamp = async(webuserID) => {
    const url = configData.CCBHTableauAPIServer + "/password/validatetimestamp?username=" + webuserID;
    try{
        const response = await fetch(url, { 
            method:"GET", 
            headers: {
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }    
};

export const changePassword = async(username, password) => {
    const url = configData.CCBHTableauAPIServer + "/password/changepassword"; //?webuserID=" + username + "&password=" + password;
    const response = await fetch(url,{
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            'webuserid': username,
            "password": password,
            "managerId":'manager',
            "roles": []
        }),
    });
    const responseJson = await response.json();
    console.log('Password changed', responseJson);
    
    return responseJson;
};
